import React from "react";
import { CreditCardIcon, FileDownIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { product } from "../data/landing";
const trustItems = [{
  icon: FileDownIcon,
  label: "Digital PDF bundle"
}, {
  icon: CreditCardIcon,
  label: "One-time payment"
}];
export function Hero() {
  return <section className="bg-white" data-id="element-51" data-mp="4mrxb9ifkfpg">
      <div className="mx-auto flex max-w-[1000px] flex-col items-center px-5 pb-8 pt-6 text-center sm:px-8 lg:pb-12 lg:pt-10" data-id="element-52" data-mp="4jm69oq8r3r3">
        <p className="inline-flex items-center gap-2 rounded-full border border-line bg-white px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-navy sm:text-[11px]" data-id="element-53" data-mp="xanpq20yvlgf">
          <span className="h-1.5 w-1.5 rounded-full bg-teal" aria-hidden="true" data-id="element-54" data-mp="sd48ct8z2sk9" />
          For HR professionals &amp; internal trainers
        </p>
        <h1 className="mt-4 max-w-[900px] font-display text-[36px] font-extrabold uppercase leading-[0.95] tracking-[-0.01em] text-navy sm:text-5xl lg:text-[64px]" data-id="element-55" data-mp="3d2le7pgobt71">
          Your next manager workshop. <span className="text-teal" data-id="element-56" data-mp="3j9k9t8cxxbej">Already planned.</span>
        </h1>

        <img src={product.mockup} alt="New Manager Essentials box set: 10 planned workshops plus 5 bonuses, digital PDF bundle" width={1024} height={1536} className="mt-5 h-[40svh] max-h-[500px] min-h-[240px] w-auto rounded-2xl bg-soft shadow-[0_20px_45px_rgba(19,34,56,0.18)] lg:h-[46vh]" data-id="element-57" data-mp="3o7c4291259lw" />

        <CtaButton href="#offer-details" className="mt-6 w-full max-w-[480px]" data-id="element-58" data-mp="30gq4z7916zo1">
          Get the workshop kit
        </CtaButton>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-muted sm:text-sm" data-id="element-59" data-mp="2qjv8etwbj9ce">
          {trustItems.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5" data-id="element-60" data-mp="2vj7tpa7jk8cv">
              <Icon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-61" data-mp="2hk84o1g49rg6" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}